export default __webpack_public_path__ + "static/10-74bf14709dde167be9c2312c6755c388.jpg";